import { AUTOMATION_OPERATOR_AND, createConditionGroup } from '@components/PositionAutomation/conditionFormHelpers';

export const createAutomationEditorSlice = () => ({
    data: null,
    loading: false,
    error: null,
    loaded: false,
});

export const createAutomationConfigsSlice = () => ({
    data: null,
    loading: false,
    error: null,
});

export const createActionResourcesSlice = () => ({
    data: null,
    loading: false,
    error: null,
    actionId: null,
});

export const createEmptyConditionGroup = () => createConditionGroup();

export const createEmptyAutomationRuleForm = () => ({
    event: null,
    cron: [],
    groups: [],
    topOperator: AUTOMATION_OPERATOR_AND,
    actionValue: {},
});

export const createUiSlice = () => ({
    automationModal: null,
    fetchingRuleId: null,
    automationRuleForm: createEmptyAutomationRuleForm(),
    automationRuleHydratedId: null,
    automationRuleSaving: false,
});

export const emptyAutomationRulesByStep = {};
export const emptyAutomationRulesByOutcome = {};

export const initialState = {
    automationEditor: createAutomationEditorSlice(),
    automationConfigs: createAutomationConfigsSlice(),
    actionResources: createActionResourcesSlice(),
    ui: createUiSlice(),
    rulesByStep: emptyAutomationRulesByStep,
    rulesByOutcome: emptyAutomationRulesByOutcome,
};
